export default __webpack_public_path__ + "static/media/logo-big.4407c952.svg";